import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";

import { Partner, PracticeType, PartnerPageContent, ServiceCategoryCard } from "@customTypes/partner";

export interface UpdatePartnerPayload {
  whatsapp_number?: string;
  page_content?: PartnerPageContent;
  service_categories?: ServiceCategoryCard[];
  name?: string;
  enterprise_id?: string;
  is_organization?: boolean;
  practice_type?: PracticeType;
  description?: string;
  contact_email?: string;
  contact_phone?: string;
  address?: string;
  city?: string;
  country?: string;
  registration_number?: string;
  tax_id?: string;
  is_active?: boolean;
  slug?: string;
  visibility?: "public" | "private";
  website?: string;
  social_media?: Record<string, string>;
  color_palette?: readonly string[] | string[];
  accent_color?: string;
  brief_description?: string;
  specialties?: string[];
  accreditations?: string[];
  established_year?: number;
  operating_hours?: string;
  payout_method?: string;
  bank_account_number?: string;
  bank_name?: string;
  mobile_money_number?: string;
  mobile_money_provider?: string;
  mobile_money_country_code?: string;
  joonapay_entity_uuid?: string;
  joonapay_country_uuid?: string;
  joonapay_method_uuid?: string;
  joonapay_mobile_money_account_uuid?: string;
  joonapay_bank_account_uuid?: string;
}

export const useUpdatePartner = (partnerId: string) => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (payload: UpdatePartnerPayload) => {
      const { data } = await api.patch<Partner>(`partners/${partnerId}`, payload);
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Partner updated successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.partners(),
      });
    },
    onError: (res: any) => {
      console.error("[From Update Partner Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
